const data_CN = {
  topPage: {
    rightImg:require("@/assets/topPage/18.png"),
    englishName:'CHANNEL SERVICE',
    name:'渠道服务',
    introText:'OFFSHORE为了方便产品或服务企业将产品或服务推广到最终用户手中，提供的一系列服务和支持。通过数字平台提供广泛的渠道策略、分销解决方案、定位工具、数字营销支持、多渠道客户支持和培训等服务。',
    bottomImg:true
  },
  operation: {
    socialMedia: {
      title: '社媒运营',
      content: '通过社交媒体平台为企业进行在线推广和营销的活动。它能够以更低的成本进行广告投放，实现品牌宣传、产品销售、客户招募等多种业务目标。要做好社交媒体运营，需要选择适当的平台，制定营销策略，与社区互动，监控并分析数据，最终转化为盈利能力。',
      channel: '支持渠道',
      list:
      [
        {imageSrc: require("@/assets/channelServices/icon_line.png"),name:'Line'},
        {imageSrc: require("@/assets/channelServices/icon_telegram.png"),name:'Telegram BOT'},
        {imageSrc: require("@/assets/channelServices/icon_whatsapp.png"),name:'WhatsApp'},
        {imageSrc: require("@/assets/channelServices/icon_wechat.png"),name:'Wechat'},
        {imageSrc: require("@/assets/channelServices/icon_youtube.png"),name:'Youtube'},
        {imageSrc: require("@/assets/channelServices/icon_facebook.png"),name:'Fackbook'},
      ]
    },
    eCommerce: {
      title: '电商运营',
      content: '',
      channel: '支持渠道',
      list:
      [
        {imageSrc: require("@/assets/channelServices/icon_amazon.png"),name:'Amazon'},
        {imageSrc: require("@/assets/channelServices/icon_taobao.png"),name:'Alibaba'},
        {imageSrc: require("@/assets/channelServices/icon_rakutan.png"),name:'rakuten'}
      ]
    },
    liveBroadcast: {
      title: '直播运营',
      content: '',
      channel: '支持渠道',
      list:
      [
        {imageSrc: require("@/assets/channelServices/icon_whatsapp.png"),name:'WhatsApp'},
        {imageSrc: require("@/assets/channelServices/icon_facebook.png"),name:'Fackbook'},
        {imageSrc: require("@/assets/channelServices/icon_ins.png"),name:'Instagram'},
        {imageSrc: require("@/assets/channelServices/icon_tiktok.png"),name:'Tik Tok'}
      ]
    }
  }
}
const data_JA = {
  topPage: {
    rightImg:require("@/assets/topPage/18.png"),
    englishName:'CHANNEL SERVICE',
    name:'チャネルサービス',
    introText:'OFFSHOREは、製品やサービス企業がエンドユーザーに製品やサービスを普及させるために提供する一連のサービスとサポートを提供しています。デジタルプラットフォームを通じて広範なチャネル戦略、流通ソリューション、分析ツール、デジタルマーケティングサポート、マルチチャネルカスタマーサポート、トレーニングなどのサービスを提供する。',
    bottomImg:true
  },
  operation: {
    socialMedia: {
      title: 'ソーシャルメディア運営',
      content: 'ソーシャルメディアプラットフォームを通じた企業向けのオンラインプロモーションおよびマーケティング活動。 低コストで広告宣伝を実施でき、ブランドプロモーション、商品販売、顧客獲得などのさまざまなビジネス目標を達成できます。 ソーシャルメディア運用で良い仕事をするには、適切なプラットフォームを選択し、マーケティング戦略を策定し、コミュニティと対話し、データを監視および分析し、最終的にそれを収益に変える必要があります。',
      channel: 'サポートチャンネル',
      list:
      [
        {imageSrc: require("@/assets/channelServices/icon_line.png"),name:'Line'},
        {imageSrc: require("@/assets/channelServices/icon_telegram.png"),name:'Telegram BOT'},
        {imageSrc: require("@/assets/channelServices/icon_whatsapp.png"),name:'WhatsApp'},
        {imageSrc: require("@/assets/channelServices/icon_wechat.png"),name:'Wechat'},
        {imageSrc: require("@/assets/channelServices/icon_youtube.png"),name:'Youtube'},
        {imageSrc: require("@/assets/channelServices/icon_facebook.png"),name:'Fackbook'},
      ]
    },
    eCommerce: {
      title: 'Eコマース運営',
      content: '',
      channel: 'サポートチャンネル',
      list:
      [
        {imageSrc: require("@/assets/channelServices/icon_amazon.png"),name:'Amazon'},
        {imageSrc: require("@/assets/channelServices/icon_taobao.png"),name:'Alibaba'},
        {imageSrc: require("@/assets/channelServices/icon_rakutan.png"),name:'rakuten'}
      ]
    },
    liveBroadcast: {
      title: 'ライバー運営',
      content: '',
      channel: 'サポートチャンネル',
      list:
      [
        {imageSrc: require("@/assets/channelServices/icon_whatsapp.png"),name:'WhatsApp'},
        {imageSrc: require("@/assets/channelServices/icon_facebook.png"),name:'Fackbook'},
        {imageSrc: require("@/assets/channelServices/icon_ins.png"),name:'Instagram'},
        {imageSrc: require("@/assets/channelServices/icon_tiktok.png"),name:'Tik Tok'}
      ]
    }
  }
}
 
const data_EN = {
  topPage: {
    rightImg:require("@/assets/topPage/18.png"),
    englishName:'CHANNEL SERVICE',
    name:'Channel Service',
    introText:'OFFSHORE provides a series of services and supports for the convenience of product or service companies to promote products or services to end users. Provides a wide range of channel strategies, distribution solutions, positioning tools, digital marketing support, multi-channel customer support and training through digital platforms.',
    bottomImg:true
  },
  operation: {
    socialMedia: {
      title: 'Social media operation',
      content: 'Online promotion and marketing activities for businesses through social media platforms. It can carry out advertising at a lower cost, and achieve various business goals such as brand promotion, product sales, and customer recruitment. To do a good job in social media operations, you need to choose the appropriate platform, formulate marketing strategies, interact with the community, monitor and analyze data, and finally turn it into profitability.',
      channel: 'Support channel',
      list:
      [
        {imageSrc: require("@/assets/channelServices/icon_line.png"),name:'Line'},
        {imageSrc: require("@/assets/channelServices/icon_telegram.png"),name:'Telegram BOT'},
        {imageSrc: require("@/assets/channelServices/icon_whatsapp.png"),name:'WhatsApp'},
        {imageSrc: require("@/assets/channelServices/icon_wechat.png"),name:'Wechat'},
        {imageSrc: require("@/assets/channelServices/icon_youtube.png"),name:'Youtube'},
        {imageSrc: require("@/assets/channelServices/icon_facebook.png"),name:'Fackbook'},
      ]
    },
    eCommerce: {
      title: 'E-commerce operation',
      content: '',
      channel: 'Support channel',
      list:
      [
        {imageSrc: require("@/assets/channelServices/icon_amazon.png"),name:'Amazon'},
        {imageSrc: require("@/assets/channelServices/icon_taobao.png"),name:'Alibaba'},
        {imageSrc: require("@/assets/channelServices/icon_rakutan.png"),name:'rakuten'}
      ]
    },
    liveBroadcast: {
      title: 'Live operation',
      content: '',
      channel: 'support channel',
      list:
      [
        {imageSrc: require("@/assets/channelServices/icon_whatsapp.png"),name:'WhatsApp'},
        {imageSrc: require("@/assets/channelServices/icon_facebook.png"),name:'Fackbook'},
        {imageSrc: require("@/assets/channelServices/icon_ins.png"),name:'Instagram'},
        {imageSrc: require("@/assets/channelServices/icon_tiktok.png"),name:'Tik Tok'}
      ]
    }
  }
}

export default {
  data_CN,
  data_JA,
  data_EN
}


// WEBPACK FOOTER //
// ./src/common/json/channelServices.js